export default __webpack_public_path__ + "static/media/promo-card-curves.e9bbe092.svg";